import * as Others from "./others";
import * as Pages from "./pages";

export default { Others, Pages };



// WEBPACK FOOTER //
// ./src/store/repo/index.js